import React from "react";
import { BsTwitter, BsGithub, BsLinkedin } from "react-icons/bs";

const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="https://twitter.com/Dazai9016">
          <BsTwitter size="2x" />
        </a>
      </div>
      <div>
        <a href="https://github.com/Takeru9016">
          <BsGithub size="2x" />
        </a>
      </div>
      <div>
        <a href="https://www.linkedin.com/in/sahiljadhav/">
          <BsLinkedin size="2x" />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
